"use client";

import Image from "next/image";
import { useEffect, useState } from "react";
import { isCapacitorNative } from "../product-cookie";

type Provider = { id: string; name: string; icon: string };

type Props = {
  provider: Provider;
  isLoading: boolean;
  isLastUsed: boolean;
  onSubmit: (e: React.FormEvent) => void;
};

export default function ProviderButton({
  provider,
  isLoading,
  isLastUsed,
  onSubmit,
}: Props) {
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    if (provider.id === "microsoft" && isCapacitorNative()) setHidden(true);
  }, [provider.id]);

  if (hidden) return null;

  return (
    <form method="post" onSubmit={onSubmit} className="relative">
      {isLastUsed && (
        <span className="absolute -top-2 left-3 z-10 bg-black text-white text-[10px] font-medium leading-none px-1.5 py-1 rounded">
          Last used
        </span>
      )}
      <button
        className="w-full py-4 rounded-2xl text-center focus:outline-[#05B0FF] font-medium bg-white text-black border flex items-center justify-center gap-2"
        type="submit"
        disabled={isLoading}
      >
        <Image
          src={provider.icon}
          alt={`${provider.name} logo`}
          width={15}
          height={15}
        />
        <span>Continue with {provider.name}</span>
      </button>
    </form>
  );
}
